import onePassword from './passkey-provider-icons/onepassword.svg'
import applePasswords from './passkey-provider-icons/apple-passwords.svg'
import iCloudKeychain from './passkey-provider-icons/icloud-keychain.svg'
import googlePasswordManager from './passkey-provider-icons/google-password-manager.svg'
import microsoftPasswordManager from './passkey-provider-icons/microsoft-password-manager.svg'
import bitwarden from './passkey-provider-icons/bitwarden.svg'
import dashlane from './passkey-provider-icons/dashlane.svg'

// Dark-background icons from https://github.com/passkeydeveloper/passkey-authenticator-aaguids.
// The API derives these display names from AAGUIDs during registration.
const icons: Record<string, string> = {
    '1Password': onePassword,
    'Apple Passwords': applePasswords,
    'iCloud Keychain': iCloudKeychain,
    'Google Password Manager': googlePasswordManager,
    'Microsoft Password Manager': microsoftPasswordManager,
    Bitwarden: bitwarden,
    Dashlane: dashlane
}

export default function passkeyProviderIcon(name: string): string | undefined {
    return icons[name]
}
